import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController, AlertController, ModalController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ReservationsServices } from "../services";
import { ConfigurationServices } from '../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { DeniedReservationPage } from '../../components/popups/denied-reservation/denied-reservation';
import { HttpClient } from '@angular/common/http';
import { CustomersServices } from '../../customers/services';
import { SearchServices } from '../../services/searchs';
import * as firebase from 'firebase';
import { SearchReservationsServices } from '../../services/searchsReservation';
/**
 * Generated class for the ReservationCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-reservation-manual-create',
    templateUrl: 'reservation-manual-create.html',
})
export class ReservationManualCreatePage {
    public form: FormGroup;
    update_state: boolean = false;
    reservation: any = [];
    date: any;
    event: any;
    adutls: any;
    children: any;
    phone: any;
    email: any;
    message: any;
    public covermanager: boolean = false;
    firestore: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public fb: FormBuilder,
        public toastCtrl: ToastController,
        public reservationsServices: ReservationsServices,
        public alertCtrl: AlertController,
        public configurationServices: ConfigurationServices,
        public translate: TranslateService,
        public modalCtrl: ModalController,
        public http: HttpClient,
        public customersServices: CustomersServices,
        public searchServices: SearchServices,
        public searchReservationsServices: SearchReservationsServices) {

        this.firestore = firebase.firestore();

        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();

        this.reservation = this.navParams.get('reservation');
        this.update_state = this.navParams.get('update_state');
        this.date = this.navParams.get('date');
        this.event = this.navParams.get('event');


        if (this.update_state) {
            //
            this.checkInfoIFCustomerExists();
            //
            this.form = fb.group({
                name: this.reservation.name,
                date: [this.reservation.date, Validators.compose([Validators.required])],
                stripe: [this.reservation.stripe, Validators.compose([Validators.required])],
                hour: this.reservation.hour,
                adults: this.reservation.adults,
                children: this.reservation.children,
                phone: this.reservation.phone,
                email: this.reservation.email,
                message: this.reservation.message,
                UID_CLIENT: this.reservation.UID_CLIENT,
                date_order: this.reservation.date_order,
                customer_table: this.reservation.customer_table
            });

            if (this.reservation.covermanager_id == undefined) {
                this.covermanager = false;
            } else {
                this.covermanager = true;
            }

            this.globals.GAtrackView('Reservations', 'Reservations - View', this.globals.restaurant.email, 'View', 'View reservation', 'Reservations', this.form.value.name);

        } else {
            this.getCustomers();
            this.covermanager = false;
            this.form = fb.group({
                name: ['', Validators.compose([Validators.required])],
                date: [this.date, Validators.compose([Validators.required])],
                stripe: ['1', Validators.compose([Validators.required])],
                hour: '',
                adults: 0,
                children: 0,
                phone: '',
                email: '',
                message: '',
                UID_CLIENT: '',
                customer_table: ''
            });


        }
        //Guardamos el form en searchService
        this.searchServices.form = this.form;
        this.searchReservationsServices.form = this.form;
        loadingPopup.dismiss();

    }

    submit() {
        if (this.form.valid) {
            if (!this.update_state) {
                this.insert();
            } else {
                this.update();
            }
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-introduce-nombre-fecha-franja'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    insert() {
        this.reservationsServices.afs.collection('reservations').add({
            UID_RESTAURANT: this.globals.restaurant_uid,
            name: this.form.value.name,
            date: this.form.value.date,
            stripe: this.form.value.stripe,
            hour: this.form.value.hour,
            adults: this.form.value.adults,
            children: this.form.value.children,
            phone: this.form.value.phone,
            email: this.form.value.email,
            message: this.form.value.message,
            delete: false,
            UID_CLIENT: this.searchServices.selectedPersonId,
            state: 'accepted',
            date_order: this.reservationsServices.returnOrderDate(this.form.value.date, this.form.value.hour),
            customer_table: this.form.value.customer_table,
            created_at: new Date(),
            updated_at: new Date()
        }).then(doc => {
            this.globals.GAtrackView('Reservations', 'Reservations - Create', this.globals.restaurant.email, 'Create/Update', 'Create reservation', 'Reservations', this.form.value.name);
            var reservation = {
                UID: doc.id,
                UID_RESTAURANT: this.globals.restaurant_uid,
                name: this.form.value.name,
                date: this.form.value.date,
                stripe: this.form.value.stripe,
                hour: this.form.value.hour,
                adults: this.form.value.adults,
                children: this.form.value.children,
                phone: this.form.value.phone,
                email: this.form.value.email,
                message: this.form.value.message,
                delete: false,
                UID_CLIENT: '',
                state: 'accepted',
            };
            //present toast
            this.presentAcceptedToast();
            //send mail
            this.sendEmail('confirm', reservation, '');
            //prepare extra
            var extra = {
                "adults": this.form.value.adults,
                "children": this.form.value.children,
                "hour": this.form.value.hour,
            };
            var total = parseInt(this.form.value.adults) + parseInt(this.form.value.children);
            this.globals.dataSet('reservation', total, '', JSON.stringify(extra), '');//Send reservation data
            this.navCtrl.popToRoot();
            //this.value_changes.unsuscribe();
        });
    }

    update() {
        this.reservationsServices.afs.collection('reservations').doc(this.reservation.UID).update({
            name: this.form.value.name,
            date: this.form.value.date,
            stripe: this.form.value.stripe,
            hour: this.form.value.hour,
            adults: this.form.value.adults,
            children: this.form.value.children,
            phone: this.form.value.phone,
            email: this.form.value.email,
            message: this.form.value.message,
            UID_CLIENT: this.form.value.UID_CLIENT,
            date_order: this.reservationsServices.returnOrderDate(this.form.value.date, this.form.value.hour),
            customer_table: this.form.value.customer_table
        }).then(() => {
            this.globals.GAtrackView('Reservations', 'Reservations - Update', this.globals.restaurant.email, 'Create/Update', 'Update reservation', 'Reservations', this.form.value.name);
            //prepare extra
            var extra = {
                "adults": this.form.value.adults,
                "children": this.form.value.children,
                "hour": this.form.value.hour,
            };
            var total = parseInt(this.form.value.adults) + parseInt(this.form.value.children);
            this.globals.dataSet('reservation', total, '', JSON.stringify(extra), '');//Send reservation data
            this.navCtrl.popToRoot();
        });
    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-reserva'),
            message: this.translate.instant('instant-seguro-quieres-eliminarla'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.reservationsServices.afs.collection('reservations').doc(this.reservation.UID).update({
                            delete: true,
                        }).then(() => {
                            this.globals.GAtrackView('Reservations', 'Reservations - Delete', this.globals.restaurant.email, 'Delete', 'Delete reservation', 'Reservations', this.reservation.name);
                            this.navCtrl.popToRoot();
                        });
                    }
                }
            ]
        });
        alert.present();
    }

    recuperar() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-recuperar-reserva'),
            message: this.translate.instant('instant-seguro-quieres-recuperar-reserva'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.reservationsServices.afs.collection('reservations').doc(this.reservation.UID).update({
                            delete: false,
                        }).then(() => {
                            this.globals.GAtrackView('Reservations', 'Reservations - Recover - Update', this.globals.restaurant.email, 'Create/Update', 'Update recover reservation', 'Reservations', this.reservation.name);
                            this.navCtrl.popToRoot();
                        });
                    }
                }
            ]
        });
        alert.present();
    }


    confirmReservation() {
        this.reservationsServices.afs.collection('reservations').doc(this.reservation.UID).update({
            name: this.form.value.name,
            date: this.form.value.date,
            stripe: this.form.value.stripe,
            hour: this.form.value.hour,
            adults: this.form.value.adults,
            children: this.form.value.children,
            phone: this.form.value.phone,
            email: this.form.value.email,
            message: this.form.value.message,
            UID_CLIENT: this.form.value.UID_CLIENT,
            state: 'accepted',
            delete: false,
            date_order: this.reservationsServices.returnOrderDate(this.form.value.date, this.form.value.hour),
            customer_table: this.form.value.customer_table
        }).then(async () => {
            //recuperamos reserva actualizada
            this.reservation = await this.reservationsServices.getReservation(this.reservation.UID);
            //present toast
            this.presentAcceptedToast();
            //send mail
            this.sendEmail('confirm', this.reservation, '');
            //pop
            this.navCtrl.pop();
        });
    }

    denyReservation() {
        //lanzamos modal con textarea para que ponga el motivo
        let profileModal = this.modalCtrl.create(DeniedReservationPage, { title: this.translate.instant('general-denegar-reserva') });
        profileModal.onDidDismiss(data => {

            //caso que tocan fuera del modal
            if (data == null) {
                this.presentReasonToast();
            } else if (data != '') {
                this.reservationsServices.afs.collection('reservations').doc(this.reservation.UID).update({
                    name: this.form.value.name,
                    date: this.form.value.date,
                    stripe: this.form.value.stripe,
                    hour: this.form.value.hour,
                    adults: this.form.value.adults,
                    children: this.form.value.children,
                    phone: this.form.value.phone,
                    email: this.form.value.email,
                    message: this.form.value.message,
                    UID_CLIENT: this.form.value.UID_CLIENT,
                    state: 'denied',
                    delete: true,
                    date_order: this.reservationsServices.returnOrderDate(this.form.value.date, this.form.value.hour),
                    reason: data,
                    customer_table: this.form.value.customer_table
                }).then(async () => {
                    //recuperamos reserva actualizada
                    this.reservation = await this.reservationsServices.getReservation(this.reservation.UID);
                    //present toast
                    this.presentDeniedToast();
                    //send mail
                    this.sendEmail('deny', this.reservation, data);
                    //pop
                    this.navCtrl.pop();
                });

            } else if (data != false) {
                this.presentReasonToast();
            }
        });
        profileModal.present();
    }

    async sendEmail(state, reservation, reason) {
        //tener en cuenta que el email y otros datos si viene de deliverecto no son el customer_name y etc
        var logo;
        if (!this.globals.logo_url) {
            logo = '';
        } else {
            await this.globals.logo_url.subscribe(data => {
                logo = data;
            });
        }

        let _email = {
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'type': 'reservation_accepted',
            'customer_name': reservation.name,
            'customer_email': reservation.email,
            'customer_phone': reservation.phone,
            'restaurant_logo': logo,
            'restaurant_company': this.globals.restaurant.company,
            'restaurant_address': this.globals.restaurant.address,
            'restaurant_email': this.globals.restaurant.email,
            'restaurant_phone': this.globals.restaurant.phone,
            'restaurant_lang': this.globals.restaurant.lang,
            'comment': reservation.message,
            'date': reservation.date,
            'hour': reservation.hour,
            'persons': reservation.adults,
            'public_key': this.globals.public_key,
            'uid_reservation': reservation.UID,
            'reservation_text_web': this.globals.ifVarEmpty(this.globals.restaurant.reservation_text_web)
        }
        this.firestore.collection('_emails').add(_email);
    }

    presentReasonToast() {
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-motivo-denegar-reserva'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    presentAcceptedToast() {
        let toast = this.toastCtrl.create({
            message: this.translate.instant('instant-reserva-aceptada-enviando-email'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    presentDeniedToast() {
        let toast = this.toastCtrl.create({
            message: this.translate.instant('instant-reserva-denegada-enviando-email'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    presentEmailOKToast() {
        let toast = this.toastCtrl.create({
            message: this.translate.instant('instant-reserva-email-enviando-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    presentEmailErrorToast() {
        let toast = this.toastCtrl.create({
            message: this.translate.instant('instant-reserva-email-enviando-error'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    public customers: any;
    customer: any;
    selected: any;
    selectedId: any;
    async checkInfoIFCustomerExists() {
        await this.getCustomers();
        this.customer = await this.reservationsServices.checkInfoIFCustomerExists(this.reservation.email, this.reservation.phone);

        if (this.customer) {
            this.form.get('UID_CLIENT').setValue(this.customer.UID);
            this.selected = this.customer.name + ' - ' + this.customer.email;
            this.selectedId = this.customer.UID
        }
    }

    async getCustomers() {
        this.customers = await this.customersServices.getCustomers(this.globals.restaurant_uid);
    }


    createCustomer() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        this.customersServices.afs.collection('customers').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'name': this.form.value.name,
            'business_name': '',
            'business_number': '',
            'email': this.form.value.email,
            'phone': this.form.value.phone,
            'address': '',
            'note': '',
            'created_at': new Date()
        }).then(doc => {
            this.reservationsServices.afs.collection('reservations').doc(this.reservation.UID).update({
                UID_CLIENT: doc.id,
            })
            this.form.get('UID_CLIENT').setValue(doc.id);
            loadingPopup.dismiss();
        });
    }

}


// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-manual-create/reservation-manual-create.ts